export const UtmGuideHeader = (): JSX.Element => (
  <div className="utm-guide-header">
    <h5 className="heading mx-0 mt-0 text-[#2b3674] mb-3">
      <b>
        For each platform you have ads on, please add UTM tracking. Follow the
        instructions for each platform below to do so.
      </b>
    </h5>
    <p>
      Northbeam requires your advertising to have UTM parameters added on every
      platform.
    </p>
    <p>
      If you advertise on a channel that is NOT listed below, please reach out
      to <a href="mailto:success@northbeam.io">success@northbeam.io</a> and we
      will be happy to assist you.
    </p>
    <p>
      These UTMs give us the data that is necessary to accurately report with
      our platform. In some situations, we are able to automatically place UTMs.
      Unless already stated in instructions below, this is typically a manual
      part of onboarding.
    </p>
    <p>
      <b>
        Note: If you skip any of your platforms, your reporting will be
        significantly limited on that platform. Additionally, you should begin
        by adding tracking parameters to <em>Klaviyo</em> and{" "}
        <em>Google Ads</em>, if applicable.
      </b>
    </p>
    <p>
      Our UTMs are all ADDITIVE, meaning they can be appended to your existing
      UTMs and will not impact your performance or tracking. The order of UTMs
      does not matter, meaning you can add our UTMs to the beginning or the end
      of your existing UTM parameters (just make sure there is an “&” separating
      them).
    </p>
    <p className="font-semibold">
      We accept any Standard UTM parameters: utm_source, utm_medium,
      utm_campaign, utm_content, utm_term
    </p>
    <hr className="mb-0" />
  </div>
);
